module.exports = " <div class=\"paint-app pixelated\" v-bind:class=\"{color: state.colorDisplay }\"> <div class=\"background overlay stretchy greentone\" style=\"z-index: -2\"></div> <div class=\"background2 overlay stretchy halftone\" style=\"z-index: -1\"></div> <win-header v-bind:title=\"'Paint - '+ state.title\"></win-header> <file-menu></file-menu> <tool-bar></tool-bar> <drawing-panel></drawing-panel> <bottom-bar show-disk=1></bottom-bar> <palettes></palettes> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaintApp.vue
// module id = 177
// module chunks = 2